import React from "react";

import AssignedToMeHeading from "./AssignedToMeHeading";
import CardLists from "./CardLists";
import { useAssignedTaskPanelState } from "../hooks/useAssignedTaskPanelState";

function AllMyTask() {
  const { anchorEl, filter, handleClose, handleOpen, setFilter } =
    useAssignedTaskPanelState();

  return (
    <div className="assign-to-me">
      <AssignedToMeHeading
        filter={filter}
        anchorEl={anchorEl}
        setFilter={setFilter}
        handleClose={handleClose}
        handleOpen={handleOpen}
      />
      <div className="assign-to-me-body">
        <CardLists filter={filter} />
      </div>
    </div>
  );
}

export default AllMyTask;
